@if(isLoader()) {
<app-loader></app-loader> }
<div class="modal-header">
    <div></div>
    <h5 class="modal-title">{{ 'notification.template.emailTemplate' | translate }}</h5>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()" tabindex="0"  (keydown.enter)="close()"
    ></button>
</div>
<div class="modal-body">
    <div class="tabs-container">
        <ul>
          <li class="tab" [ngClass]="{ 'active': isPreviewActive}"
          tabindex="0" (click)="toggleTemplateTab(true)">{{ 'notification.template.preview' | translate }}</li>
          <li class="tab" [ngClass]="{ 'active': !isPreviewActive}"
          tabindex="0" (click)="toggleTemplateTab(false)">{{ 'notification.template.edit' | translate }}</li>
        </ul>
    </div>
    <div class="preview-body" [ngClass]="{ 'd-none' : !isPreviewActive}">
        @if (defaultTemplatePreview()) {
        <div id="template-warning-holder" class="template-warning mb-3">
            <img src="/assets/images/Warning.svg" alt="Warning icon" width="26px">
            <span id="template-warning-message">{{ 'notification.template.defaultTemplateMessage' | translate }}</span>
        </div> }
        <div class="template-block d-flex flex-column w-100">
            <div class="template-header">
                <div class="d-flex gap-3 p-3 align-items-center">
                    <div class="custom-template-icon"></div>
                    <div class="d-flex flex-column bg-white flex-fill gap-2">
                        <div class="email-template-box">
                            <span style="display: inline-block; width: 60px;">{{ 'notification.template.from' | translate }}</span>
                            <span id="fromEmail">{{"notification.fromMailId" | translate }}</span>
                        </div>
                        <div class="email-template-box">
                            <span style="display: inline-block; width: 60px;">{{ 'notification.template.subject' | translate }}</span>
                            <span id="subject">{{previewTemplateSubject}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column p-3 template-body">
                <span class="ms-auto mb-2 me-2 link" id="viewPlainTextLink" data-ad-target="preview-plainText">{{ 'notification.template.plainTextMessage' | translate }}</span>
                <span class="ms-auto mb-2 me-2 link d-none" id="viewStyledLink" data-ad-target="preview-full">{{ 'notification.template.styleTextMessage' | translate }}</span>
                <div id="preview-full" class="email-body-template w-100" style="font-size: 12px;font-weight: 400;line-height: 1.4;color: #174770;font-family: 'readex pro', sans-serif;width: 100%; border-radius: 16px; background-color: white;">
                </div>
                <div id="preview-plainText" class="email-body-template w-100 d-none">
                </div>
            </div>
        </div>
    </div>
    <div class="edit-body" [ngClass]="{ 'd-none' : isPreviewActive}">
        <div class="template-block d-flex flex-column w-100">
            <div class="template-header form gap-3 p-3">
                <div class="input-container m-0">
                    <label for="inputSubject">{{ 'notification.template.emailSubject' | translate }}</label>
                    <input type="text" class="input-field" id="inputSubject"
                    value="Shopper receipt for transaction {transactionID}" [(ngModel)]="updateTemplateSubject">
                </div>
            </div>
            <div class="form email-template-input align-items-center w-100 d-flex flex-column gap-3 pb-3">
                @if (notificationTemplateFlag()) {
                <div class="tinymce-editor" #editorContainer>
                    <!-- Adding template content to tinymce through initialValue until APIs are configured -->
                    <editor [init]="editorConfig">
                    </editor>
                </div> }

                <div class="d-flex flex-column align-items-start w-100 px-3">
                    <div class="d-flex justify-content-between w-100 gap-3">
                        <!-- Revert Changes should only be visible if a change has been made on the template. -->
                        <button class="button button-clear" (click)="revertToLastSave()"
                            ad-tooltip data-body="Remove all updates made to your template this session.">
                            {{ 'notification.template.revertToLastSave' | translate }}
                        </button>
                        <button class="button button-green" (click)="saveContent()">
                            {{ 'notification.template.saveTemplate' | translate }}
                        </button>
                    </div>
                    @if (resetToDefaultFlag()) {
                    <span id="resetAllContent" data-ad-target="confirmTemplateReset"
                        ad-tooltip data-body="Returns the template to its system default.<br />All changes will be lost."
                        role="button" tabindex="0" (keydown.enter)="resetContent(); $event.stopPropagation()" (click)="resetContent(); $event.stopPropagation()">
                            {{ 'notification.template.ResetToSystemDefaultTemplate' | translate }}
                        </span> }
                </div>
            </div>
        </div>
    </div>
</div>

